// Mock data for GwadaPlaisance website

export const SITE = {
  name: "GWADAPLAISANCE",
  tagline: "EXCURSIONS EN MER",
  subtitle: "Vivez la Guadeloupe autrement !",
  phone: "0690 58 76 46",
  phoneRaw: "0690587646",
  whatsappNumber: "590690587646", // international format for wa.me
  email: "gwadaplaisance@gmail.com",
  location: "Le Gosier – Guadeloupe",
  locationDetail: "(Grand Cul de Sac Marin)",
  address: "GWADAPLAISANCE – Le Gosier, Guadeloupe",
  siteUrl: "https://gwadaplaisance.com",
};

export const NAV_ITEMS = [
  { id: "accueil", label: "ACCUEIL", href: "#accueil" },
  { id: "excursions", label: "EXCURSIONS", href: "#excursions" },
  { id: "tarifs", label: "TARIFS", href: "#tarifs" },
  { id: "photos", label: "PHOTOS", href: "#photos" },
  { id: "apropos", label: "À PROPOS", href: "#apropos" },
  { id: "contact", label: "CONTACT", href: "#contact" },
];

export const HERO_FEATURES = [
  { icon: "anchor", title: "SORTIES EN MER", subtitle: "AUTHENTIQUES" },
  { icon: "palm", title: "ÎLETS PARADISIAQUES", subtitle: "PRÉSERVÉS" },
  { icon: "mask", title: "SNORKELING", subtitle: "EAUX TURQUOISES" },
  { icon: "sun", title: "DÉTENTE & PLAISIR", subtitle: "GARANTIS" },
];

export const EXCURSIONS = [
  {
    id: "ilet-caret",
    title: "ÎLET CARET",
    description: "L'un des plus beaux îlets du lagon. Baignade et mouillage autour du site",
    duration: "1/2 journée",
    price: 50,
    image: "https://images.unsplash.com/photo-1553603227-2358aabe821e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGlzbGV0fGVufDB8fHx8MTc4Mzk3MTAxOXww&ixlib=rb-4.1.0&q=85",
    badge: "Baignade & mouillage",
    notice: "Îlet fermé au débarquement jusqu'au 31 déc. 2026 (travaux de revégétalisation). Baignade et mouillage autorisés.",
    highlights: [
      "Baignade en lagon turquoise",
      "Mouillage autour de l'îlet",
      "Photos souvenirs inoubliables",
      "Snorkeling autour du site",
    ],
  },
  {
    id: "mangrove",
    title: "MANGROVE",
    description: "Découverte de la mangrove et de la biodiversité",
    duration: "1/2 journée",
    price: 55,
    image: "https://images.unsplash.com/photo-1618344322727-2256d3abdd1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtYW5ncm92ZXxlbnwwfHx8fDE3ODM5MzAyMDh8MA&ixlib=rb-4.1.0&q=85",
    highlights: [
      "Éco-système unique en Guadeloupe",
      "Faune et flore protégées",
      "Passage dans les canaux de palétuviers",
      "Explications de notre équipage",
    ],
  },
  {
    id: "snorkeling",
    title: "SNORKELING",
    description: "Explorez les fonds marins, poissons tropicaux et coraux",
    duration: "1/2 journée",
    price: 50,
    image: "https://images.unsplash.com/photo-1496196614460-48988a57fccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxzZWElMjB0dXJ0bGV8ZW58MHx8fHwxNzgzOTcxMDE5fDA&ixlib=rb-4.1.0&q=85",
    highlights: [
      "Rencontre avec tortues marines",
      "Barrière de corail préservée",
      "Poissons tropicaux multicolores",
      "Spots secrets connus des locaux",
    ],
  },
  {
    id: "coucher-soleil",
    title: "COUCHER DE SOLEIL",
    description: "Moment magique en mer avec ambiance musicale et apéritif local",
    duration: "Soirée",
    price: 65,
    image: "https://customer-assets.emergentagent.com/job_gwada-qr-code/artifacts/ufuwzzzw_WhatsApp%20Image%202026-07-13%20at%2019.48.02.jpeg",
    highlights: [
      "Coucher de soleil sur la mer des Caraïbes",
      "Apéritif créole offert",
      "Ambiance musicale zouk & reggae",
      "Souvenir inoubliable en famille",
    ],
  },
];

export const FULL_DAY_EXCURSION = {
  title: "GRAND CUL-DE-SAC MARIN",
  subtitle: "Journée complète",
  departure: "9H00",
  departurePoint: "Marina du Gosier",
  includes: "Apéritif + Repas + Dessert compris — Repas by Besson Grill Plus",
  notIncluded: "Masques, tubas et palmes non fournis",
  groupSize: "12 personnes maximum",
  description:
    "Une journée inoubliable dans le lagon protégé du Grand Cul-de-Sac Marin, en petit groupe (12 personnes maximum), à bord d'un bateau rapide et confortable. Au programme : découverte de la mangrove, snorkeling autour d'une épave, détente sur des îlets idylliques et un repas barbecue original, directement dans l'eau, sur des tabourets et matelas flottants. Boissons, plats savoureux à volonté, ambiance conviviale, capitaines expérimentés. Une expérience unique et raffinée pour profiter pleinement des richesses de la Guadeloupe.",
  program: [
    "Découverte de la mangrove et son éco-système",
    "Snorkeling autour d'une épave",
    "Détente sur des îlets idylliques",
    "Barbecue les pieds dans l'eau (tabourets & matelas flottants)",
    "Boissons et plats à volonté",
    "Étoile de mer & barrière de corail",
    "Ambiance conviviale avec capitaines expérimentés",
  ],
  prices: [
    { label: "Adulte", value: 120 },
    { label: "Enfant (-12 ans)", value: 95 },
    { label: "Bébés (-2 ans)", value: 0 },
  ],
  disclaimer: "Matériel de plongée (masques, tubas, palmes) non fourni.",
};

export const ILET_CARET_ALERT = {
  active: true,
  title: "FERMETURE ÎLET CARET",
  subtitle: "jusqu'au 31 décembre 2026",
  reason: "Travaux de revégétalisation du site",
  allowed: [
    "Possibilité de mouillage",
    "Possibilité de baignade",
  ],
  forbidden: [
    "Interdiction de poser les pieds sur l'îlet",
  ],
};

export const COMMITMENTS = [
  {
    icon: "shield",
    title: "SÉCURITÉ",
    description: "Matériel de sécurité et équipage qualifié",
  },
  {
    icon: "users",
    title: "PETITS GROUPES",
    description: "Convivialité et service personnalisé",
  },
  {
    icon: "clock",
    title: "DÉPART FLEXIBLE",
    description: "Horaires adaptés à vos envies",
  },
  {
    icon: "leaf",
    title: "RESPECT DE LA NATURE",
    description: "Excursions responsables et écoresponsables",
  },
];

export const PHOTOS = [
  "https://images.unsplash.com/photo-1778706141531-8c84ceb23470?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxHdWFkZWxvdXBlJTIwdHVycXVvaXNlfGVufDB8fHx8MTc4Mzk3MTAxOXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1553603227-2358aabe821e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGlzbGV0fGVufDB8fHx8MTc4Mzk3MTAxOXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1618344322727-2256d3abdd1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtYW5ncm92ZXxlbnwwfHx8fDE3ODM5MzAyMDh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1496196614460-48988a57fccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxzZWElMjB0dXJ0bGV8ZW58MHx8fHwxNzgzOTcxMDE5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1503327431567-3ab5e6e79140?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxzdW5zZXQlMjBib2F0fGVufDB8fHx8MTc4Mzk3MTAxOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1620326467418-14c39a82ebe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzcGVlZGJvYXQlMjB0dXJxdW9pc2V8ZW58MHx8fHwxNzgzOTcxMDE4fDA&ixlib=rb-4.1.0&q=85",
];

export const TESTIMONIALS = [
  {
    name: "Marie L.",
    text: "Une journée magique ! L'équipage est aux petits soins, le bateau est confortable et les lieux à couper le souffle. On recommande vivement !",
    rating: 5,
  },
  {
    name: "Julien D.",
    text: "Le snorkeling au-dessus de la barrière de corail était incroyable. On a nagé avec des tortues ! Merci Gwadaplaisance pour ce moment inoubliable.",
    rating: 5,
  },
  {
    name: "Sophie & Marc",
    text: "Coucher de soleil parfait, apéritif créole excellent et ambiance familiale. Bravo pour votre professionnalisme !",
    rating: 5,
  },
];

// Real photos & video from Gwadaplaisance (only the most impactful)
export const MEDIA = {
  boatMain: "https://customer-assets.emergentagent.com/job_gwada-qr-code/artifacts/q9dwjgfb_WhatsApp%20Image%202026-07-13%20at%2018.10.46%40.jpeg",
  sunset: "https://customer-assets.emergentagent.com/job_gwada-qr-code/artifacts/ufuwzzzw_WhatsApp%20Image%202026-07-13%20at%2019.48.02.jpeg",
  video: "https://customer-assets.emergentagent.com/job_gwada-qr-code/artifacts/mdecma7q_WhatsApp%20Video%202026-07-13%20at%2019.47.31.mp4",
};

export const buildWhatsAppLink = (message = "") => {
  const base = `https://wa.me/${SITE.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};
